










import { Component, Mixins, Prop, Emit } from "vue-property-decorator";
import { ExternalImageItem } from "../../../../../../domain/externalImage";
import { IImageDragParameter } from "../../../../../dragging";

@Component({
  components: {
  }
})
export default class ExternalImagePreview extends Mixins() {
  @Prop()
  item: ExternalImageItem;

  get imageSource(): string {
    return this.item
      ? this.item.source.source
      : null;
  }

  onDragStart(event: DragEvent): void {
    const data: IImageDragParameter = {
      isExternalImage: true,
      externalImageDragParameter: {
        patientId: this.item.patientId,
        externalImageId: this.item.id,
        imageDateTime: this.item.imageDateTime,
      }
    };
    const text = JSON.stringify(data);
    // 第一引数(format)が"text"でないとIEでエラーになる。
    event.dataTransfer.setData("text", text);
  }

  onDoubleClicked(): void {
    this.doubleClick(this.item);
  }

  @Emit()
  doubleClick(src: ExternalImageItem): void {}
}
